export const translations = {
  site_name: 'KombiKurumsalServis',
  nav_home: 'Ana Sayfa',
  nav_services: 'Hizmetler',
  nav_brands: 'Markalar',
  nav_about: 'Hakkımızda',
  nav_contact: 'İletişim',
  hero_title_1: 'Profesyonel',
  hero_title_2: 'Kombi Bakım &',
  hero_title_3: 'Onarım Hizmeti',
  hero_subtitle: 'Yılların tecrübesiyle, tüm marka kombiler için güvenilir bakım ve onarım hizmetleri sunuyoruz. Hızlı, güvenli ve ekonomik çözümler.',
  hero_cta_call: 'Hemen Ara',
  hero_cta_discover: 'Ücretsiz Keşif',
  hero_trust: '15+ Yıllık Deneyim',
  services_title: 'Hizmetlerimiz',
  service_maintenance: 'Kombi Bakım',
  service_maintenance_desc: 'Yıllık periyodik bakım, verimlilik artırma ve uzun ömür garantisi. Tüm marka kombiler için uzman bakım hizmeti.',
  service_repair: 'Arıza Onarımı',
  service_repair_desc: 'Kısa sürede profesyonel çözüm. Garantili yedek parça değişimi ve 7/24 acil servis desteği.',
  service_installation: 'Kombi Montajı',
  service_installation_desc: 'Yeni kombi montajı ve eski cihaz değişimi. Uzman ekibimizle güvenli ve standartlara uygun kurulum.',
  brands_title: 'Servis Verdiğimiz Markalar',
  brands_subtitle: 'Türkiye\'nin önde gelen tüm kombi markalarına yetkili servis hizmeti veriyoruz.',
  brands_cta: 'Servis Al',
  about_label: 'Neden Biz?',
  about_title: 'Güvenilir Kombi Servisi, Hızlı Çözüm',
  about_desc: '2009 yılından bu yana kombi bakım ve onarım sektöründe faaliyet gösteriyoruz. Profesyonel ekibimiz, orijinal yedek parça kullanımımız ve müşteri memnuniyetine verdiğimiz önemle sektörde güvenilir bir isim olduk. Her servis ziyaretimizde müşterilerimize en kaliteli hizmeti sunmak için çalışıyoruz.',
  about_cta: 'Daha Fazla Bilgi',
  testimonials_title: 'Müşteri Yorumları',
  testimonials_subtitle: 'Müşterilerimiz bizim için ne dedi?',
  contact_title: 'Bize Ulaşın',
  contact_subtitle: 'Kombi sorununuz mu var? Hemen bize ulaşın, uzman ekibimiz en kısa sürede size dönüş yapsın.',
  contact_name: 'Adınız',
  contact_email: 'E-posta Adresiniz',
  contact_phone: 'Telefon Numaranız',
  contact_service: 'Hizmet Türü',
  contact_message: 'Mesajınız',
  contact_submit: 'Gönder',
  contact_success: 'Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.',
  service_maintenance_short: 'Bakım',
  service_repair_short: 'Onarım',
  service_installation_short: 'Montaj',
  footer_slogan: 'Güvenilir kombi servisi, profesyonel çözümler.',
  footer_rights: 'Tüm hakları saklıdır.',
  footer_quick_links: 'Hızlı Linkler',
  footer_services: 'Hizmetler',
  footer_brands: 'Markalar',
  footer_copyright: '© KombiKurumsalServis 2025',
};